export default {
  login: {
    title: "SYSTEM LOGIN",
    logIn: "Login",
    username: "Account",
    password: "Password",
  },
  wrongpwd:
    "Uppercase + digits cannot be less than 8 characters. Special symbols are not supported",
  首页: "Wallet",
  行情: "Quotes",
  财富: "Assets",
  我的: "MY",
  忘记密码: "Forgot password",
  确定: "Confirm",
  "忘记密码？": "Lost password",
  登录: "Login",
  注册: "Sign up",
  云端钱包: "Wallet",
  世界顶尖安全保护: "The world's top security protection",
  "独有资产增益，注册存币坐享收益":
    "Exclusive asset gain, register to deposit coins to enjoy the income",
  "支持超过30+主流币和500+代币":
    "Support more than 30+ mainstream coins and 500+ tokens",
  HD钱包: "HD wallet",
  "100%掌管私钥，资产更放心":
    "100% control of private keys, more assured assets",
  "一键导入助记词，方便好用":
    "One-click import mnemonic words, convenient and easy to use",
  设置登录密码: "Setting login password",
  确认: "Confirm",
  手机注册: "sign up for a mobile phone",
  已有账号: "Already have an account",
  去登录: "Go to log in",
  最近流行: "Recently popular",
  全部: "all",
  拖动排序: "Drag to sort",
  立即创建: "Create Now",
  您支付: "Payment amount",
  可换余额: "Exchangable amount",
  请在以下时间内完成支付以锁定此汇率:
    "Please complete the payment within the following time to lock in this exchange rate",
  您获得: "You get",
  "您获得的币种为空时,说明没有币种可以闪兑。":
    "If you don't choose a coin, you can't exchange it.",
  立即兑换: "exchange",
  备份钱包助记词: "Backup wallet mnemonic",
  "1.由12个字符组成，请抄写并保管在安全的地方。":
    "1. It consists of 12 characters, please copy it and keep it in a safe place. ",
  "2.100%由您保管，一经丢失，无法找回。":
    "2.100% is kept by you, once lost, it cannot be retrieved. ",
  "3.请在收币或卸载之前，务必完成助记词备份。":
    "3. Please make sure to complete the backup of the mnemonic phrase before receiving the currency or uninstalling it. ",
  立即备份: "Back up now",
  "我先看看，稍后再说": "I'll take a look first, I'll talk about it later",
  请环顾四周: "Please look around",
  "任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。":
    "Anyone who obtains the mnemonic means that he has obtained your assets. Please make sure that there is no one around and no cameras. ",
  知道了: "understood",
  请输入验证码: "enter the authentication code",
  "没有收到验证码？": "Haven't received the verification code? ",
  交易时间: "transaction hour",
  交易ID: "Transaction ID",
  来自: "From",
  发送到: "send to",
  备注: "Remark",
  发送: "Withdrawal",
  闪兑: "Exchange",
  接收: "Deposit",
  交易记录: "Transaction History",
  "正在刷新...": "Refreshing...",
  "正在加载...": "loading...",
  暂无相关记录: "No data.",
  重新设置支付密码: "Reset payment password",
  "请将上方的16位恢复秘钥备份在安全的地方，遗失秘钥将无法恢复两步验证":
    "Please back up the 16-bit recovery key above in a safe place. If the key is lost, the two-step verification will not be restored.",
  我已设置并备份秘钥: "I have set and backed up the secret key",
  "谷歌两步验证可以为您的账户增加一层保护，当您登陆或者进行交易时，在输入密码的同时，还需要来自两步验证的验证码":
    "Google two-step verification can add a layer of protection to your account. When you log in or make a transaction, when you enter your password, you also need a verification code from two-step verification.",
  "如何使用谷歌两步验证?": "How to use Google two-step verification?",
  筛选: "filter",
  移除: "Remove",
  添加: "Add to",
  总资产: "Total assets",
  创建钱包: "Create wallet",
  导入钱包: "Import wallet",
  邀请好友: "Invitation",
  发红包: "gift",
  扫一扫: "scan it",
  地址簿: "Address book",
  历史公告: "Notice",
  设置: "Settings",
  请选择您的证件的颁发国家:
    "Please select the issuing country of your certificate",
  查看助记词: "View mnemonic words",
  "您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。":
    "You can import the mnemonic phrase to pair on other devices, or use the HMC Wallet Pro wallet on other devices to scan the QR code for pairing. ",
  "请勿截图！如果有人获取你的助记词将直接获取你的资产！":
    "Don't take a screenshot! If someone gets your mnemonic phrase, they will get your assets directly!",
  查看加密二维码: "View encrypted QR code",
  "加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。":
    "Encrypting the QR code is to facilitate the wallet to pair with the new device, please do not save the screenshot, and make sure that there are no other people around or hidden cameras. ",
  "该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。":
    "This QR code is only available for HMC Wallet Pro wallet. When scanning, you need to enter the PIN code of the current APP in the APP to be imported to successfully import the corresponding mnemonic phrase. ",
  "请抄写 HMC Wallet Pro 助记词":
    "Please copy the HMC Wallet Pro mnemonic phrase",
  "HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。":
    "HMC Wallet Pro mnemonic phrase is used to restore the wallet. Please copy the 12 words below on paper in order and save it in a safe place. ",
  我已安全保存: "I have saved it safely",
  "HMC Wallet Pro需要您提政府颁发的照片ID来通过安全验证":
    "HMC Wallet Pro requires you to submit a photo ID issued by the government to pass security verification",
  提交: "submit",
  设置收款金额: "Set the payment amount",
  收款金额: "Received amount",
  复制收款码: "Copy Payment Code",
  取消: "Cancel",
  安全验证: "Security verification",
  "验证失败，请重试": "Verification failed, please try again",
  当前域名未授权验证:
    "Domain not authorized for Turnstile. Add this hostname in Cloudflare.",
  发送成功: "Sent successfully",
  数量: "quantity",
  "为了您的账户安全,请输入原支付密码确认身份。": "enter your current password",
  "忘记支付密码?": "Forgot to pay password?",
  将配好的红包分享给好友: "Share the red envelope with your friends",
  个: "Piece",
  "请确认 HMC Wallet Pro 助记词":
    "Please confirm HMC Wallet Pro mnemonic phrase",
  "为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。":
    "In order to ensure that you have copied the HMC Wallet Pro mnemonic correctly, please select the word corresponding to the serial number. ",
  "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。":
    "Additional security settings and real-name information are required for the safety of the asset, and the withdrawal limit will increase depending on the rating when set.",
  恢复助记词钱包: "Restore mnemonic wallet",
  "请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词":
    'Please enter the mnemonic phrase in the form below to reply to the wallet. After each mnemonic phrase is entered, press the "space" key to jump to the next word',
  开始恢复: "Start recovery",
  "覆盖当前钱包？": "Overwrite the current wallet? ",
  "导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。":
    "Importing a wallet will overwrite the current wallet. If you have not backed up, the current wallet will disappear forever. ",
  继续导入: "Import",
  全部发送: "Send all",
  交易费: "Fee",
  慢: "slow",
  快: "quick",
  已有红包: "Alreadyhavearedenvelope",
  生成红包: "Generate red envelopes",
  确认支付: "confirm payment",
  可在已有红包页面查看领取详情:
    "You can check the claim details on the existing red envelope page",
  级: "class",
  退出登录: "Logout",
  全部划转: "Transfer all",
  查看规则: "View rules",
  请输入支付密码: "Please enter payment password",
  币计划活期: "Deposit",
  币计划定期: "Savings",
  预期年化收益: "Expected annualization",
  我的财富: "Total assets ",
  币计划: "CoinPlan",
  热门推荐: "Recommended product",
  交易查询: "Transaction History",
  财富资产: "Total Assets ",
  累计收益: "Cumulative revenue",
  预期年化收益率: "Expected annualized rate of return",
  交易规则: "Trading Rules",
  买入: "Buy",
  起息日: "Value date",
  到期日: "expiry date",
  产品亮点: "Product Highlights",
  剩余额度: "Remaining quota",
  立即购买: "Buy now",
  昨日收益: "Yesterday Earnings",
  划入: "deposit",
  划出: "transfer",
  全部划出: "Strike out all",
  请输入谷歌二次验证码: "Please enter the Google secondary verification code",
  点击登录: "Click to Login",
  "欢迎来到HMC Wallet Pro": "Welcome to HMC Wallet Pro",
  邀请奖励: "Invitation",
  每日快讯: "News",
  联系客服: "Customer Center",
  邀请累计: "Accumulated reserves",
  积分: "integral",
  好友注册人数: "Friends registered",
  好友注册: "Invitation registration ",
  人数: "/person",
  一级好友数: "1class member.",
  "积分 每人奖励": "{msg} points per person",
  二级好友数: "2class member.",
  三级好友数: "3class member.",
  一级好友数2: "1class member.",
  二级好友数2: "2class member.",
  三级好友数2: "3class member.",
  "积分 每人奖励2": "{msg} points per person",
  好友存币数: "Invitation to Deposit",
  邀请列表: "Invitation List",
  邀请注册: "Invitation registration",
  邀请存币: "Invitation to Deposit",
  暂时没有邀请哦: "No invitation yet",
  当前总额: "Current total",
  积分账单: "Points bill",
  任务: "Task",
  商城: "Mall",
  "忘记PIN码？备份钱包后重新安装App并导入助记词后重置":
    "Forgot PIN code? After backing up the wallet, reinstall the App and reset after importing the mnemonic phrase",
  "为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。":
    "In order to protect the security of your assets, please set a PIN code first. The PIN code will be used to unlock the wallet and send money. ",
  "PIN码为本地密码，请妥善保存，如果丢失，无法恢复":
    "The PIN code is a local password, please keep it properly, if it is lost, it cannot be recovered",
  关闭PIN码: "Turn off PIN code",
  "扫码下载HMC Wallet Pro": "Scan code to download HMC Wallet Pro",
  "邀请码(点击复制)": "Invitation Code (Copy)",
  查看邀请详情: "View invitation details ",
  我的订单: "My Order",
  正在进行中: "In progress",
  已经结束: "It's over",
  人参与: "People involved",
  兑换金额: "Exchange amount",
  商品详情: "product details",
  兑换时间: "Exchange time",
  开始时间: "Starting time",
  结束时间: "End Time",
  我的积分: "My scores",
  我的剩余兑换额度: "My remaining redemption limit",
  库存总量: "Total inventory",
  剩余库存: "Remaining inventory",
  兑换比例: "Exchange ratio",
  确认兑换: "Confirm Redemption",
  任务记录: "Task record",
  分享: "share",
  请填写手机号: "enter your mobile phone number ",
  验证码: "Authentication code",
  设置密码: "Enter your password",
  再次输入: "Re-enter password",
  请填写密码: "enter your password",
  邀请码: "Invitation code (select)",
  我的Dapp钱包: "My Dapp Wallet",
  发现: "Find",
  搜索: "search",
  自定义排序: "Custom Sort",
  货币: "currency",
  创建新地址: "Create new address",
  名称: "name",
  地址: "Address",
  请输入金额: "Enter the amount",
  验证您的身份: "Verify your identity",
  选择币种: "Select currency",
  设置支付密码: "Payment password setting",
  谷歌两步验证码: "Google two-step verification code",
  谷歌两步验证: "Google two-step verification",
  请输入搜索内容: "Enter search content",
  选择证件类型: "Select document type",
  支付密码: "Payment Password",
  修改支付密码: "Change payment password",
  认证资料: "Authentication Information",
  国家: "nation",
  您的居住国家: "Your country of residence",
  姓名: "Name",
  您的姓名全称: "Your full name",
  生日: "Birthday",
  居住地: "Residence",
  您现在的居住地: "Your current residence",
  证件ID: "DocumentID",
  您的证件ID号码: "Your ID number",
  ID正面照片: "ID front photo",
  ID反面照片: "ID reverse photo",
  请输入数值: "Please enter a value",
  已配置红包: "Red envelopes configured",
  重置支付密码: "Change payment password",
  红包详情: "Red envelope details",
  安全等级: "security level",
  请输入收款地址: "Enter deposit address",
  "备注(选填)": "optional",
  配置红包: "Configure red envelopes",
  金额: "Amount",
  红包数: "Number",
  请填写个数: "Please fill in the number",
  红包总额度: "Red envelope total amount",
  红包数量: "Number of red envelopes",
  祝福语: "Greetings",
  选择发送途径: "Choose delivery method",
  云端钱包设置: "Setting",
  账户名称: "account name",
  注册时间: "Registration date",
  请输入划入金额: "Please enter the credited amount",
  请输入转出金额: "Please enter the transfer amount",
  谷歌二次验证: "Google Secondary Verification",
  默认货币: "Currency",
  PIN码: "PIN code",
  行情选项: "Quote Options",
  服务协议: "Terms and Conditions",
  隐私政策: "Privacy Policy",
  帮助中心: "tip",
  加入社群: "Telegram",
  我的邀请: "View invitation details >",
  验证PIN码: "Verify PIN code",
  设置PIN码: "Set PIN code",
  行情显示色选项: "Quotes display color options",
  请输入兑换金额: "Please enter the exchange amount",
  任务中心: "Task Center",
  快讯: "Express News",
  "已开启(重置)": "Opened (reset)",
  已开启: "Opened",
  未开启: "Unopened",
  绿涨红跌: "Green up, red down",
  红涨绿跌: "Red up, green down",
  全部交易: "All transactions",
  增益收入: "Profit",
  全部产品: "All products ",
  全部币种: "All coins",
  当前余额: "Current balance",
  钱包: "wallet",
  今日获得: "Get today",
  "我已备份好当前钱包，同意覆盖":
    "I have backed up the current wallet and agree to overwrite it",
  备份助记词: "Backup mnemonic",
  "助记词即为私钥，它是掌管您财产的钥匙":
    "The mnemonic is the private key, which is the key to control your property",
  完成: "Done",
  下一步: "Next",
  默认语言: "language",
  "没有HMC Wallet Pro账号？": "Don’t have an HMC Wallet Pro account?",
  获取验证码: "Authentication code send",
  验证错误: "Verification error",
  验证成功: "Successful verification",
  验证失败: "verification failed:",
  设置成功: "Set successfully",
  请选择同意: "Please choose to agree",
  云端钱包公告: "Cloud wallet announcement",
  HD钱包公告: "HD wallet announcement",
  云端钱包地址簿: "Cloud wallet Address",
  HD钱包地址簿: "HD wallet Address",
  收款地址: "deposit address",
  请填写完整: "Please complete",
  复制成功: "Copy successfully",
  复制出现异常: "Copy error",
  资产名: "Name",
  交易量: "Volume",
  价格: "Price",
  "涨跌幅(24H)": "Change (24H)",
  内部转账: "Internal transactions ",
  外部转账: "External transactions",
  请输入收款用户ID: "Please enter the recipient user ID",
  邮箱注册: "Sign up for e-mail ",
  邮箱登录: "E-mail login",
  手机登录: "Mobile phone login ",
  邮箱验证: "E-mail authentication ",
  手机验证: "Mobile phone authentication",
  请填写邮箱号: "enter your email address ",
  公链: " Chain",
  游戏: "Game",
  我的游戏: "Game",
  社区: "Community",
  链游: "Related Products ",
  全部动态: "All posts ",
  热门游戏: "top games",
  我的关注: "favorites",
  发布: "posting",
  分享新鲜事: "Share your new news.",
  发布动态: "Write a post",
  个人主页: "Change profile",
  全文: "full text",
  评论: "Comment",
  赞: "great",
  没有更多了: "no more",
  暂无数据: "No data.",
  提示: "hint",
  "提币前必须绑定google验证码": "Google Authenticator must be bound before withdrawal",
  请选择文件: "Please select file",
  请输入动态内容: "Please enter dynamic content",
  确定删除该图片吗: "Are you sure you want to delete this image",
  上传文件类型错误: "Incorrect upload file type",
  请选择要上传的图片: "Please select an image to upload",
  匿名用户: "Anonymous User",
  收起: "put away",
  查看所有评论: "View all comments",
  确定删除该动态吗: "OK to delete this activity",
  动态详情: "Dynamic details",
  删除: "Delete",
  有趣的评论万里挑一: "Funny comments one in a million",
  请输入内容: "Please enter content",
  回复: "Reply",
  暂无签名: "No signature yet",
  已关注: "Followed",
  关注: "focus on",
  删除成功: "successfully deleted",
  打开: "Open",
  写下你的评论: "write your review",
  个人资料: "Personal information ",
  点击修改: "Click to modify",
  昵称: "Nickname",
  ID: "ID",
  手机号: "phone number",
  个性签名: "Status message",
  添加图片或视频: "Add photo or video",
  可用资产: "Available asset ",
  锁定资产: "freezing assets",
  转账: "transfer",
  收款: "Collection",
  钱包管理: "Invitation",
  锁仓截止日期: "Lockup Deadline",
  锁定: "locking",
  交易所: "Platform",
  量化交易: "Quantitative trading",
  角色信息: "Role information",
  绑定角色: "Bind Role",
  服务区: "Service Area",
  请选择服务区: "Please select a service area",
  角色: "Role",
  请选择角色: "Please select a role",
  绑定: "Bind",
  绑定成功: "Binding succeeded",
  立即绑定: "Bind now",
  未绑定: "NotBind",
  MetaEx交易所: "MetaEarth EX",
  AI机器人: "Aleph Bot",
  邮箱注册: "Sign up for e-mail ",
  请填写邮箱号: "enter your email address ",
  返回首页: "Wellet",
  BTC公链: "BTC Chain",
  ETH公链: "ETH Chain",
  HMC公链: "HMC Chain",
  HMC20: "HMC20",
  实名认证: "Real name authentication",
  请先设置支付密码: "Please set a payment password first",
  立即认证: "Authenticate now",
  已认证: "Certified",
  谷歌验证器: "Google Authentication",
  两步验证: "Two-factor authentication",
  "如何使用谷歌验证器?": "How to set up Google authentication",
  所有币种: "All currencies",
  已添加币种: "Currency added",
  未添加币种: "Currency not added",
  邮箱: "E-mail",
  手机: "Mobile phone",
  获取: "Get",
  推荐: "recommend",
  利空: "bearish",
  利好: "bullish",
  请填写完整的助记词: "Please fill in the complete mnemonic phrase",
  "不是正确的助记词,请重新输入": "Not the correct mnemonic, please re-enter",
  empty: "Please complete",
  noequal: "The two inputs are not equal",
  invite: "Please enter the six-digit invitation code",
  认证失败: "Failed",
  修改密码: "Change Password",
  待审核: "To audit",
  旧密码: "Previous password",
  新密码: "New password",
  请确认新密码: "Re-enter your password",
  立即修改: "confirm",
  请填写完整表单: "Please fill out the complete form",
  两次密码不一致: "The two passwords are different",
  认证状态: "Real name authentication",
  身份认证失败: "Authentication failed",
  失败原因: "the cause of failure",
  重新认证: "Re-certification",
  审核中: "under examination",
  已完成身份认证: "authentication completion",
  国籍: "country",
  类型: "Type",
  身份证: "Identification card",
  护照: "Passport",
  驾照: "driving license",
  证件号码: "ID number",
  已完成实名认证: "Realname authentication complete",
  身份验证: "authentification",
  请输入手机验证码: "Enter your mobile phone authentication number",
  发送验证码: "Send ",
  请输入邮箱验证码: "enter your email authentification code.",
  请输入谷歌验证码: "Please enter your Google Authentication Number",
  输入邮箱验证码: "enter your email authentification code.",
  输入手机验证码: "Enter your mobile phone authentication number",
  输入谷歌验证码: "Enter Google Authentication Number",
  谷歌验证: "Google Authentication",
  立即验证: "Confirm",
  发送验证码至手机: "Send the verification code to the mobile phone",
  发送验证码至邮箱: "Send verification code to email",
  忘记支付密码: "Finding a Payment Password",
  输入新密码: "Enter a new password",
  请再次输入: "Enter new password again",
  请输入密码: "enter a new password",
  请输入邮箱: "Please enter email address",
  绑定邮箱: "Binding email",
  请输入手机号: "Please enter your cell phone number",
  区号: "Areacode",
  请选择区号: "Please select the area code",
  绑定手机号: "Linkyourphonenumber",
  "谷歌验证可以为您的账户增加一层保护，当您登录或者进行交易时，再输密码的同时，还需要来自谷歌验证的验证码":
    "When setting up Google authentication, protection is added to your account, and you need an authentication number issued by Google along with entering a password when logging in or trading.",
  可用余额不足: "ashortageofbalance",
  地址格式不正确: "Invalidaddressformat",
  金额不足10: "Less than 10",
  提币数量不能小于: "Withdrawalamountisgreaterthanholdingamount",
  "您还未进行实名认证,请先进行实名认证":
    "Wehaven'tverifiedyourrealnameyet,sopleaseverifyyourrealnamefirst",
  "您还未同时绑定手机号和邮箱，请前往设置页完善":
    "You have not bound both phone and email yet. Please go to Settings to complete.",
  "为保障账号安全，请绑定手机后再继续操作":
    "For account security, please bind your phone number before continuing.",
  "为保障账号安全，请绑定邮箱后再继续操作":
    "For account security, please bind your email before continuing.",
  "去绑定": "Bind Now",
  至少为10: "For at least 10",
  全选: "SelectAll",
  请先勾选地址: "Please tick the address first",
  新建地址: "NewAddress",
  提币网络: "Main network",
  收款网络: "Main network",
  "操作成功!": "Processing succeeded",
  韩国: "Korea",
  日本: "Japan",
  其他: "etc.",
  请上传手持证件照片: "Please post a picture of you holding your ID",
  请把信息填写完整: "Please fill in the information completely",
  请上传所需图片: "Please upload the required pictures",
  短信验证: "sns authentication",
  两步验证登录: "Login authentication",
  请选择验证方式: "Select an authentication mode",
  验证方式: "select an authentication method",
  验证登录: "Verifythelogin",
  证件类型: "Type",
  暂无内容: "There is no content",
  邮箱地址不符合格式: "Email address is out of format",
  下拉刷新: "Pull to refresh",
  释放更新: "Release the update",
  修改个性签名: "Change tatus Messages",
  修改昵称: "Change Nickname",
  导入NFT: "Import NFT",
  请输入NFT合约地址: "Please enter the NFT contract address",
  请输入收藏品ID: "Please enter the collection ID",
  币种: "Currency",
  添加收藏品: "Add favorites",
  暂无NFT收藏: "No NFT collection yet",
  确认删除此专辑吗: "Are you sure you want to delete this album",
  确认删除此收藏品吗: "Are you sure you want to delete this collection",
  编号: "serial number",
  删除收藏品: "Delete collection",
  保存收款碼: "QR code storage",
  PoS挖矿: "PoS Mining",
  加入社群2: "join Telegram",
  "没有HMC Wallet Pro账号？ 注册": "Sign Up",
  "已有账号，去登录": "If you are already signed up, click here",
  导入NFT: "Import NFT",
  接收地址: "receiving address",
  添加收藏品: "add favorites",
  暂无NFT收藏: "No NFT collection yet",
  编号: "serial number",
  删除: "delete",
  转出: "transfer out",
  地址: "Address",
  请输入NFT合约地址: "Please enter the NFT contract address",
  请输入收藏品ID: "Please enter the collection ID",
  添加: "Add",
  NFT接收地址: "NFT receiving address",
  复制: "copy",
  此地址仅用于NFT钱包地址接收使用:
    "This address is only used for receiving NFT wallet address",
  转出NFT: "Transfer out NFT",
  合约地址: "Contract Address",
  转出网络: "Transfer out network",
  藏品编号: "Collection number",
  转出地址: "Transfer-out address",
  "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。":
    "This transaction is irreversible. To avoid loss of your assets, please carefully check whether the transfer address and network are accurate.",
  请输入转出地址: "Please enter the transfer address",
  NFT历史记录: "NFT History",
  时间: "time",
  转入详情: "Transfer particulars",
  已转出: "turned out",
  交易详情: "Transaction Details",
  发送地址: "Sending address",
  接收地址: "Receiving address",
  网络: "Network",
  交易哈希: "Transaction hash",
  NFT合约地址: "NFT contract address",
  NFT编号: "NFT number",
  交易时间: "Trading hours",
  最小提币金额: "Minimum withdrawal amount",
};
